<nz-modal
  #modalRef
  nzSize
  [(nzVisible)]="isVisible"
  [nzTitle]="(isEdit ? 'Edit' : 'Add') + ' Arterial Blood Gases' | translate"
  (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel"
  nzOkText="Save"
  nzOkType="primary"
  [nzFooter]="null"
  class="custom-modal-class"
>
  <ng-container *nzModalContent>
    <form
      [formGroup]="arterialBloodGasForm"
      (ngSubmit)="submitForm()"
      [ngClass]="{
        'abg-submitted': arterialBloodGasSubmitted,
        'abg-not-submitted': !arterialBloodGasSubmitted
      }"
    >
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Onset Date & Time" | translate }}</label>
        </div>
        <div
          fxLayout="col"
          fxLayoutAlign="start center"
          fxFlex="70"
          fxLayoutAlign="start center"
        >
          <input
            class="inputs abg"
            type="datetime-local"
            [placeholder]="'Date' | translate"
            formControlName="dateValue"
            [max]="getCurrentDateTime()"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>pH</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs abg"
            type="number"
            [placeholder]="'pH' | translate"
            formControlName="phValue"
            min="0"
            max="10"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>HCO3</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs abg"
            type="number"
            [placeholder]="'HCO3' | translate"
            formControlName="hco3Value"
            min="0"
            max="100"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>PaCO2</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs abg"
            type="number"
            [placeholder]="'PaCO2' | translate"
            formControlName="paco2Value"
            min="0"
            max="150"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>PaO2</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs abg"
            type="number"
            [placeholder]="'PaO2' | translate"
            formControlName="pao2Value"
            min="0"
            max="250"
          />
        </div>
      </div>

      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>SaO2</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs abg"
            type="number"
            [placeholder]="'SaO2' | translate"
            formControlName="sao2Value"
            min="0"
            max="150"
          />
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end" class="footer">
        <button
          nz-button
          nzPrimary
          class="save-btn"
          type="submit"
          [nzLoading]="isLoading"
          [disabled]="isLoading"
        >
          {{ "Save" | translate }}
        </button>
        <button
          nz-button
          nzDanger
          class="cancel-btn"
          type="button"
          (click)="handleCancel()"
          [disabled]="isLoading"
        >
          {{ "Cancel" | translate }}
        </button>
      </div>
    </form>
  </ng-container>
  <ng-template>
    <button type="submit">{{ "Save" | translate }}</button>
  </ng-template>
</nz-modal>
